module.exports = __webpack_public_path__ + "img/india.35c440dc.svg";